import React from 'react';
import useTargetStorage from "@/hooks/useTargetStorage"
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Section from 'components/layout/section';
import SectionHeader from 'components/layout/sectionHeader';
import SectionHeaderTitle from 'components/layout/sectionHeaderTitle';
import PageTitle from 'features/navigation/pageTitle';
import CreateTransactionForm from 'components/transactions/CreateTransactionForm';
import { TransactionType, FormStatus } from 'types';
import useTransactions from '@/hooks/useTransactions';
import useStorages from '@/hooks/useStorages';
import { paramGuardStorage } from '@/utils/paramGuard';
import RightSidebar from '@/components/sidebar/right/RightSidebar';

const CreateTransactionPage: React.FC = () => {
  
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { targetStorageDocId: storageId } = useTargetStorage();
  const { transactionType } = useParams<{ transactionType: TransactionType }>();

  const { transactionsStatus } = useTransactions({ storageId });
  const { 
    storage,
    storageStatus,
    isTransactionsEnabled
  } = useStorages({ storageId });

  // Handle transaction type validation first
  if (
    !transactionType ||
    ![TransactionType.INCOMING, TransactionType.OUTGOING].includes(transactionType) ||
    transactionsStatus === FormStatus.ERROR
  ) {
    navigate(`/storage/transactions`);
    return <></>;
  }

  // Check params and declare safe ones to use in JSX
  if (!paramGuardStorage({storageId, storage, storageStatus, navigate})) {
    navigate(`/storage/transactions`);
    return <></>
  }
  const safeStorageId = storageId!;

  // Redirect if transactions are disabled for this storage
  if (!isTransactionsEnabled()) {
    navigate(`/storage`);
    return <></>;
  }

  return (
    <>
      <PageTitle title={transactionType === TransactionType.INCOMING ? t('titleCreateIncomingTransaction') : t('titleCreateOutgoingTransaction')} />
      <Section>
        <CreateTransactionForm 
          storageId={safeStorageId} 
          transactionType={transactionType as TransactionType} 
        />
      </Section>
      <RightSidebar storageId={safeStorageId} />
    </>
  );
};

export default CreateTransactionPage;
